import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    marginBottom: "20px",
  },

  icons_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "10px",
  },

  facebookIcon: {
    borderRadius: "50%",
    height: "23px",
  },
  linkedinIcon: {
    height: "23px",
    borderRadius: "50%",
  },

  secondRow: {},
  terms_privacy_text: {
    color: "#444444",
    fontSize: "12px",
    letterSpacing: 0,
    lineHeight: "14px",
    textDecoration: "underline",
    cursor: "pointer",
    userSelect: "none",
  },
  copyright: {
    color: "#444444",
    fontSize: "12px",
    letterSpacing: 0,
    lineHeight: "14px",
    margin: "7px 0px",
  },

  zigit: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "3px",
    color: "#000000",
    fontSize: "12px",
    letterSpacing: 0,
    fontWeight: "bold",
    cursor: "pointer",
  },

  zigitIcon_container: {
    height: "10px",
    width: "28px",
  },

  line: {
    margin: "0px 3px",
    userSelect: "none",
  },

  link: {
    cursor: "pointer",
  },
}));

export default useStyles;
